import { Action } from "history"
import { HLAResultRef } from "../types/shared/v2/HLAResult"
import { PrivacyDomain } from "../types/shared/v2/PrivacyDomain"
import { ObjectFilter, QueryObjectsOptions } from "../util/objects"
import { queryObjects, QueryObjectsRequestAction } from "./objects"

export const HLA_RESULT_INACTIVATION_NAMESPACE = 'hla-result-inactivation-v1'

export function queryPublicHLAResultInactivations(filter?: ObjectFilter, options?: QueryObjectsOptions): QueryObjectsRequestAction {
  return queryObjects(HLA_RESULT_INACTIVATION_NAMESPACE, PrivacyDomain.Public, filter, options)
}

export function queryPatientHLAResultInactivations(inlogId: string): QueryObjectsRequestAction {
  return queryObjects(HLA_RESULT_INACTIVATION_NAMESPACE, PrivacyDomain.Public, { eq: { "ref.patient.inlogId": inlogId } }, { hydrate: true })
}

export const DISABLE_HLA_RESULT_REQUEST = 'DISABLE_HLA_RESULT_REQUEST'
export const DISABLE_HLA_RESULT_SUCCESS = 'DISABLE_HLA_RESULT_SUCCESS'
export const DISABLE_HLA_RESULT_FAILURE = 'DISABLE_HLA_RESULT_FAILURE'

export function disableHLAResult(inlogId: string, hlaResult: HLAResultRef) {
  return { type: DISABLE_HLA_RESULT_REQUEST, inlogId, hlaResult }
}

export const ENABLE_HLA_RESULT_REQUEST = 'ENABLE_HLA_RESULT_REQUEST'
export const ENABLE_HLA_RESULT_SUCCESS = 'ENABLE_HLA_RESULT_SUCCESS'
export const ENABLE_HLA_RESULT_FAILURE = 'ENABLE_HLA_RESULT_FAILURE'

export function enableHLAResult(inlogId: string, hlaResult: HLAResultRef) {
  return { type: ENABLE_HLA_RESULT_REQUEST, inlogId, hlaResult }
}